<div *ngIf="czyZaladowanoDane">
  <!-- Menu administracji - Desktop -->
  <div class="container--main d-none d-md-block">
    <div class="d-flex py-4">
      <div class="project__menu">
        <a routerLink="/users">Użytkownicy</a>
        <a routerLink="/default-dictionaries">Słowniki</a>
        <a routerLink="/admin/settings">Ustawienia</a>
        <a class="active" routerLink="/admin/reports">Raporty</a>
      </div>
    </div>
  </div>

  <!-- Menu administracji - Mobile -->
  <div class="container">
    <div class="d-flex py-3 d-md-none">
      <div class="project__menu">
        <button class="btn__left"></button>
        <ngx-slick-carousel
          class="carousel menu_slider"
          #slickModal="slick-carousel"
          [config]="slideConfig"
        >
          <div ngxSlickItem class="slide">
            <a routerLink="/users">Użytkownicy</a>
          </div>
          <div ngxSlickItem class="slide">
            <a routerLink="/default-dictionaries">Słowniki</a>
          </div>
          <div ngxSlickItem class="slide">
            <a routerLink="/admin/settings">Ustawienia</a>
          </div>
          <div ngxSlickItem class="slide">
            <a class="active" routerLink="/admin/reports">Raporty</a>
          </div>
        </ngx-slick-carousel>
        <button class="btn__right"></button>
      </div>
    </div>
  </div>

  <!-- Podmenu Edycja/Podglad - Desktop -->
  <div class="container-fluid d-none d-md-block">
    <div class="podmenu-raporty py-3">
      <button class="btn__badge active" routerLink="/admin/reports-edit">
        Edycja raportów
      </button>
      <button class="btn__badge" (click)="nawigujDoPodgladuRaportow()">
        Podgląd raportów
      </button>
    </div>
  </div>

  <!-- Panel filtrow - Desktop (POZA scrollowalnym kontenerem) -->
  <div class="container-fluid d-none d-md-block">
    <div class="panel-filtrow py-3 mb-3">
      <div class="filtry-wiersz">
        <!-- Projekty multi-select -->
        <div class="filtr-projekty">
          <label>Projekty</label>
          <ng-select
            [searchable]="true"
            [clearable]="true"
            [multiple]="true"
            [items]="projekty"
            [(ngModel)]="wybraneProjektyId"
            bindLabel="nazwa"
            bindValue="id"
            [closeOnSelect]="false"
            notFoundText="Brak projektów"
            (change)="zastosujFiltry()"
          >
            <!-- Custom label gdy zwinięte - pokazuje licznik -->
            <ng-template ng-multi-label-tmp let-items="items">
              <span class="ng-value-label-count"
                >Wybrano: {{ items.length }}</span
              >
            </ng-template>

            <!-- Opcje z checkboxami -->
            <ng-template ng-option-tmp let-item="item" let-item$="item$">
              <input
                type="checkbox"
                [checked]="item$.selected"
                class="ng-option-checkbox"
              />
              <span>{{ item.nazwa }}</span>
            </ng-template>

            <!-- Nagłówek z przyciskami -->
            <ng-template ng-header-tmp>
              <div class="ng-select-header-actions">
                <button
                  type="button"
                  class="btn-select-all"
                  (click)="zaznaczWszystkieProjekty()"
                >
                  Zaznacz wszystko
                </button>
                <button
                  type="button"
                  class="btn-clear-all"
                  (click)="odznaczWszystkieProjekty()"
                >
                  Odznacz wszystko
                </button>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <!-- Pracownicy multi-select -->
        <div class="filtr-pracownicy">
          <label
            >Pracownicy
            <span class="filtr-znacznik" *ngIf="!czyPokazacWszystkichPracownikow"
              >tylko z godzinami</span
            ></label
          >
          <ng-select
            [searchable]="true"
            [clearable]="true"
            [multiple]="true"
            [items]="pracownicy"
            [(ngModel)]="wybraniPracownicyId"
            bindLabel="nazwa"
            bindValue="id"
            [closeOnSelect]="false"
            notFoundText="Brak pracowników"
            (change)="zastosujFiltry()"
          >
            <!-- Custom label gdy zwinięte - pokazuje licznik -->
            <ng-template ng-multi-label-tmp let-items="items">
              <span class="ng-value-label-count"
                >Wybrano: {{ items.length }}</span
              >
            </ng-template>

            <!-- Opcje z checkboxami -->
            <ng-template ng-option-tmp let-item="item" let-item$="item$">
              <input
                type="checkbox"
                [checked]="item$.selected"
                class="ng-option-checkbox"
              />
              <span>{{ item.nazwa }}</span>
            </ng-template>

            <!-- Nagłówek z przyciskami -->
            <ng-template ng-header-tmp>
              <div class="ng-select-header-actions">
                <button
                  type="button"
                  class="btn-select-all"
                  (click)="zaznaczWszystkichPracownikow()"
                >
                  Zaznacz wszystko
                </button>
                <button
                  type="button"
                  class="btn-clear-all"
                  (click)="odznaczWszystkichPracownikow()"
                >
                  Odznacz wszystko
                </button>

                <!-- Zawężenie do pracowników z godzinami -->
                <div class="ng-select-header-filtr">
                  <div class="chb por" (click)="przelaczPokazWszystkichPracownikow()">
                    <input
                      type="checkbox"
                      tabindex="-1"
                      [checked]="czyPokazacWszystkichPracownikow"
                    />
                    <label>Uwzględnij pracowników bez godzin</label>
                  </div>
                </div>
              </div>
            </ng-template>
          </ng-select>
        </div>

        <!-- Status projektu -->
        <div class="filtr-status">
          <label>Status projektu</label>
          <ng-select
            [items]="statusyProjektow"
            [(ngModel)]="statusProjektu"
            bindLabel="nazwa"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            (change)="zastosujFiltry()"
          ></ng-select>
        </div>

        <!-- Status pracownika -->
        <div class="filtr-status">
          <label>Status pracownika</label>
          <ng-select
            [items]="statusyPracownikow"
            [(ngModel)]="statusPracownika"
            bindLabel="nazwa"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            (change)="zastosujFiltry()"
          ></ng-select>
        </div>

        <!-- Zakres dat -->
        <div class="filtr-daty">
          <label>Zakres dat</label>
          <app-zakres-dat
            [dataOd]="dataOd"
            [dataDo]="dataDo"
            (zakresZmieniony)="naZakresZmieniony($event)"
          ></app-zakres-dat>
        </div>

        <!-- Wyczyść filtry - w tym samym wierszu -->
        <div class="filtr-wyczysc" *ngIf="czyPokazacWyczyscFiltry()">
          <label>&nbsp;</label>
          <button class="btn__clear--filter" (click)="wyczyscFiltry()">
            Wyczyść filtry
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Tabela godzin - Desktop -->
  <div class="container-fluid d-none d-md-block">
    <div class="box__scroll">
      <div class="tableFixHead tableFixHead--scrollable">
        <table class="table">
          <!-- Naglowek -->
          <thead>
            <tr>
              <th class="sticky-col sticky-col-1">Lp.</th>
              <th class="sticky-col sticky-col-2">
                Pracownik
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="kierunekSortowania.pracownik"
                  (click)="zmienSortowanie('pracownik')"
                ></button>
              </th>
              <th class="sticky-col sticky-col-3">Email</th>
              <th class="sticky-col sticky-col-4">
                Projekt
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="kierunekSortowania.projekt"
                  (click)="zmienSortowanie('projekt')"
                ></button>
              </th>
              <th class="sticky-col sticky-col-5">H</th>
              <th *ngFor="let data of daty" class="kolumna-data">
                <div class="data-header">
                  <span>{{ data.dataFormatowana }}</span>
                  <button
                    class="btn__delete"
                    (click)="potwierdzUsuwanieDnia(data.data)"
                    title="Usuń dzień"
                  ></button>
                </div>
              </th>
              <!-- ZAKOMENTOWANE - zastąpione modalem
            <th class="kolumna-dodaj">
              <button class="btn-dodaj-dzien" (click)="dodajDzien()" title="Dodaj dzień">
                +
              </button>
            </th>
            -->
              <th class="sticky-col-right">
                SUMA
                <button
                  class="btn__input--sort--bottom--gray"
                  [ngClass]="kierunekSortowania.suma"
                  (click)="zmienSortowanie('suma')"
                ></button>
              </th>
            </tr>
          </thead>

          <!-- Cialo tabeli -->
          <tbody>
            <tr *ngFor="let raport of raportyWyswietlane; let i = index">
              <td class="sticky-col sticky-col-1">{{ i + 1 }}</td>
              <td class="sticky-col sticky-col-2">{{ raport.imieNazwisko }}</td>
              <td class="sticky-col sticky-col-3">{{ raport.email }}</td>
              <td class="sticky-col sticky-col-4">{{ raport.projektNazwa }}</td>
              <td class="sticky-col sticky-col-5">
                <input
                  type="number"
                  class="input-godziny"
                  appGodziny
                  [value]="raport.domyslneGodziny"
                  (keydown.enter)="aktualizujDomyslneGodziny(raport, $event)"
                  min="0"
                  max="24"
                  step="0.5"
                />
              </td>
              <td *ngFor="let data of daty" class="kolumna-data">
                <input
                  type="number"
                  class="input-godziny"
                  [class.input-godziny--niezapisane]="czyMaNiezapisaneZmiany(raport.pracownikId, raport.projektId, data.data)"
                  appGodziny
                  [value]="pobierzGodzinyDnia(raport, data.data)"
                  (input)="naZmianeGodzinDnia(raport, data.data, $event)"
                  (keydown.enter)="aktualizujGodzinyDniaZEnter(raport, data.data, $event)"
                  min="0"
                  max="24"
                  step="0.5"
                />
              </td>
              <!-- ZAKOMENTOWANE - zastąpione modalem
            <td class="kolumna-dodaj"></td>
            -->
              <td class="sticky-col-right suma-pracownika">
                {{ obliczSumePracownika(raport) }}
              </td>
            </tr>
          </tbody>

          <!-- Stopka z sumami -->
          <tfoot>
            <tr class="wiersz-suma">
              <td class="sticky-col sticky-col-1"></td>
              <td class="sticky-col sticky-col-2 suma-label">SUMA</td>
              <td class="sticky-col sticky-col-3"></td>
              <td class="sticky-col sticky-col-4"></td>
              <td class="sticky-col sticky-col-5"></td>
              <td *ngFor="let data of daty" class="kolumna-data suma-dnia">
                {{ obliczSumeDnia(data.data) }}
              </td>
              <!-- ZAKOMENTOWANE - zastąpione modalem
            <td class="kolumna-dodaj"></td>
            -->
              <td class="sticky-col-right suma-calkowita">
                {{ obliczSumeCalkowita() }}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <!-- Paginacja - Desktop -->
    <div
      class="paginate float-right d-flex align-items-center pt-4 pb-2 pt-lg-2 mt-1"
      *ngIf="czySaWynikiNaLiscie(raportyWyswietlane)"
    >
      <div>Pokaż wyniki</div>
      <select
        class="paginate__select mx-2"
        [(ngModel)]="rozmiarTabeli"
        (change)="zmienRozmiarTabeli()"
      >
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <div class="px-2">
        {{ pobierzNumerRekorduPoczatek() }}-{{ pobierzNumerRekorduKoniec() }} z
        {{ calkowitaLiczbaElementow }}
      </div>
      <div class="d-flex">
        <button
          class="btn__left"
          *ngIf="strona > 1"
          (click)="zmienStrone(-1)"
        ></button>
        <div class="px-2">{{ strona }}</div>
        <button
          class="btn__right"
          *ngIf="czyJestWiecejRekordow"
          (click)="zmienStrone(1)"
        ></button>
      </div>
    </div>
  </div>

  <!-- Wersja mobilna -->
  <div class="container-fluid d-md-none pb-5">
    <!-- Podmenu Mobile -->
    <div class="input_container mb-3 text-right">
      <button class="btn__hamburger" (click)="pokazPodmenu()"></button>
    </div>

    <div
      class="box__mobile box__mobile--form mb-3 py-5 d-flex flex-column"
      *ngIf="czyPokazanoPodmenu"
    >
      <button
        class="btn__badge mb-4 py-2 active"
        routerLink="/admin/reports-edit"
      >
        Edycja raportów
      </button>
      <button class="btn__badge mb-4 py-2" (click)="nawigujDoPodgladuRaportow()">
        Podgląd raportów
      </button>
    </div>

    <!-- Panel filtrow - Mobile -->
    <div class="panel-filtrow-mobile mb-3">
      <!-- Projekty -->
      <div class="filtr-mobile filtr-projekty mb-2">
        <label>Projekty</label>
        <ng-select
          placeholder="Wybierz projekty"
          [searchable]="true"
          [clearable]="true"
          [multiple]="true"
          [items]="projekty"
          [(ngModel)]="wybraneProjektyId"
          bindLabel="nazwa"
          bindValue="id"
          [closeOnSelect]="false"
          notFoundText="Brak projektów"
          (change)="zastosujFiltry()"
        >
          <!-- Custom label gdy zwinięte - pokazuje licznik -->
          <ng-template ng-multi-label-tmp let-items="items">
            <span class="ng-value-label-count"
              >Wybrano: {{ items.length }}</span
            >
          </ng-template>

          <!-- Opcje z checkboxami -->
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input
              type="checkbox"
              [checked]="item$.selected"
              class="ng-option-checkbox"
            />
            <span>{{ item.nazwa }}</span>
          </ng-template>

          <!-- Nagłówek z przyciskami -->
          <ng-template ng-header-tmp>
            <div class="ng-select-header-actions">
              <button
                type="button"
                class="btn-select-all"
                (click)="zaznaczWszystkieProjekty()"
              >
                Zaznacz wszystko
              </button>
              <button
                type="button"
                class="btn-clear-all"
                (click)="odznaczWszystkieProjekty()"
              >
                Odznacz wszystko
              </button>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Pracownicy -->
      <div class="filtr-mobile filtr-pracownicy mb-2">
        <label
          >Pracownicy
          <span class="filtr-znacznik" *ngIf="!czyPokazacWszystkichPracownikow"
            >tylko z godzinami</span
          ></label
        >
        <ng-select
          placeholder="Wybierz pracowników"
          [searchable]="true"
          [clearable]="true"
          [multiple]="true"
          [items]="pracownicy"
          [(ngModel)]="wybraniPracownicyId"
          bindLabel="nazwa"
          bindValue="id"
          [closeOnSelect]="false"
          notFoundText="Brak pracowników"
          (change)="zastosujFiltry()"
        >
          <!-- Custom label gdy zwinięte - pokazuje licznik -->
          <ng-template ng-multi-label-tmp let-items="items">
            <span class="ng-value-label-count"
              >Wybrano: {{ items.length }}</span
            >
          </ng-template>

          <!-- Opcje z checkboxami -->
          <ng-template ng-option-tmp let-item="item" let-item$="item$">
            <input
              type="checkbox"
              [checked]="item$.selected"
              class="ng-option-checkbox"
            />
            <span>{{ item.nazwa }}</span>
          </ng-template>

          <!-- Nagłówek z przyciskami -->
          <ng-template ng-header-tmp>
            <div class="ng-select-header-actions">
              <button
                type="button"
                class="btn-select-all"
                (click)="zaznaczWszystkichPracownikow()"
              >
                Zaznacz wszystko
              </button>
              <button
                type="button"
                class="btn-clear-all"
                (click)="odznaczWszystkichPracownikow()"
              >
                Odznacz wszystko
              </button>

              <!-- Zawężenie do pracowników z godzinami -->
              <div class="ng-select-header-filtr">
                <div class="chb por" (click)="przelaczPokazWszystkichPracownikow()">
                  <input
                    type="checkbox"
                    tabindex="-1"
                    [checked]="czyPokazacWszystkichPracownikow"
                  />
                  <label>Uwzględnij pracowników bez godzin</label>
                </div>
              </div>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <!-- Status projektu i pracownika w jednym wierszu -->
      <div class="filtry-statusy mb-2">
        <div class="filtr-mobile filtr-mobile--half">
          <label>Status projektu</label>
          <ng-select
            [items]="statusyProjektow"
            [(ngModel)]="statusProjektu"
            bindLabel="nazwa"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            (change)="zastosujFiltry()"
          ></ng-select>
        </div>
        <div class="filtr-mobile filtr-mobile--half">
          <label>Status pracownika</label>
          <ng-select
            [items]="statusyPracownikow"
            [(ngModel)]="statusPracownika"
            bindLabel="nazwa"
            bindValue="id"
            [clearable]="false"
            [searchable]="false"
            (change)="zastosujFiltry()"
          ></ng-select>
        </div>
      </div>

      <!-- Zakres dat -->
      <div class="filtr-mobile">
        <label>Zakres dat</label>
        <app-zakres-dat
          [dataOd]="dataOd"
          [dataDo]="dataDo"
          (zakresZmieniony)="naZakresZmieniony($event)"
        ></app-zakres-dat>
      </div>
      <button
        class="btn__clear--filter mt-2 mb-4"
        (click)="wyczyscFiltry()"
        *ngIf="czyPokazacWyczyscFiltry()"
      >
        Wyczyść filtry
      </button>
    </div>

    <!-- Karty pracownikow -->
    <div class="karty-pracownikow">
      <div
        class="karta-pracownika"
        *ngFor="let raport of raportyWyswietlane; let i = index"
      >
        <div class="karta-header">
          <span class="karta-lp">{{ i + 1 }}.</span>
          <div class="karta-info">
            <span class="karta-nazwa">{{ raport.imieNazwisko }}</span>
            <span class="karta-projekt">{{ raport.projektNazwa }}</span>
          </div>
          <span class="karta-suma"
            >Suma: {{ obliczSumePracownika(raport) }}h</span
          >
        </div>
        <div class="karta-domyslne">
          <label>Domyślne H:</label>
          <input
            type="number"
            class="input-godziny"
            appGodziny
            [value]="raport.domyslneGodziny"
            (keydown.enter)="aktualizujDomyslneGodziny(raport, $event)"
            min="0"
            max="24"
            step="0.5"
          />
        </div>
        <div class="karta-dni">
          <div class="karta-dzien" *ngFor="let data of daty">
            <div class="dzien-header">
              <span class="dzien-data">{{ data.dataFormatowana }}</span>
              <button
                class="btn__delete btn__delete--mini"
                (click)="potwierdzUsuwanieDnia(data.data)"
              ></button>
            </div>
            <input
              type="number"
              class="input-godziny"
              [class.input-godziny--niezapisane]="czyMaNiezapisaneZmiany(raport.pracownikId, raport.projektId, data.data)"
              appGodziny
              [value]="pobierzGodzinyDnia(raport, data.data)"
              (input)="naZmianeGodzinDnia(raport, data.data, $event)"
              (keydown.enter)="aktualizujGodzinyDniaZEnter(raport, data.data, $event)"
              min="0"
              max="24"
              step="0.5"
            />
          </div>
        </div>
      </div>
    </div>

    <!-- ZAKOMENTOWANE - zastąpione modalem
    <button class="btn__primary mt-4" (click)="dodajDzien()">Dodaj dzień</button>
    -->

    <!-- Paginacja - Mobile -->
    <div
      class="paginate float-right d-flex align-items-center pb-2 pt-lg-4 mt-3"
      *ngIf="czySaWynikiNaLiscie(raportyWyswietlane)"
    >
      <div>Pokaż wyniki</div>
      <select
        class="paginate__select mx-2"
        [(ngModel)]="rozmiarTabeli"
        (change)="zmienRozmiarTabeli()"
      >
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
      <div class="px-2">
        {{ pobierzNumerRekorduPoczatek() }}-{{ pobierzNumerRekorduKoniec() }} z
        {{ calkowitaLiczbaElementow }}
      </div>
      <div class="d-flex">
        <button
          class="btn__left"
          *ngIf="strona > 1"
          (click)="zmienStrone(-1)"
        ></button>
        <div class="px-2">{{ strona }}</div>
        <button
          class="btn__right"
          *ngIf="czyJestWiecejRekordow"
          (click)="zmienStrone(1)"
        ></button>
      </div>
    </div>
  </div>

  <!-- Przyciski na dole strony -->
  <div class="bootom__buttons px-4 d-none d-md-block" *ngIf="czyZaladowanoDane">
    <div class="d-flex justify-content-center align-items-center">
      <button class="btn__blue" (click)="otworzModalDodajGodziny()">
        Dodaj godziny pracy
      </button>
    </div>
  </div>

  <!-- Przycisk mobile -->
  <div class="d-md-none px-3 pb-4" *ngIf="czyZaladowanoDane">
    <button class="btn__primary w-100" (click)="otworzModalDodajGodziny()">
      Dodaj godziny pracy
    </button>
  </div>
</div>
